<template>
  <div v-if="params.data" class="em-actions is-flex" @click.stop>
    <button
      type="button"
      class="em-icon-btn"
      :class="{ 'is-loading': isSelecting }"
      v-tooltip="{ content: 'Seleccionar empresa', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Seleccionar empresa"
      :disabled="isSelecting"
      @click="parent.handleSelect(params.data)"
    >
      <i class="material-icons">domain</i>
    </button>
    <button
      v-if="isAdmin"
      type="button"
      class="em-icon-btn"
      v-tooltip="{ content: 'Editar empresa', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Editar empresa"
      @click="parent.handleEdit(params.data)"
    >
      <i class="material-icons">edit</i>
    </button>
    <button
      v-if="isAdmin && !isPinned"
      type="button"
      class="em-icon-btn is-danger"
      v-tooltip="{ content: 'Eliminar empresa', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Eliminar"
      :disabled="isDeleting"
      @click="parent.handleDelete(params.data)"
    >
      <i class="material-icons">delete</i>
    </button>
  </div>
</template>

<script>
export default {
  name: "CompanyActions",
  computed: {
    parent() {
      return this.params.context.componentParent;
    },
    isAdmin() {
      return !!(this.parent.tokenUser && this.parent.tokenUser.admin);
    },
    isPinned() {
      const selectedId = this.parent && this.parent.pinnedId;
      return (
        !!(this.params.node && this.params.node.rowPinned === "top") ||
        (!!selectedId && this.params.data._id === selectedId)
      );
    },
    isSelecting() {
      return (
        !!this.params.data &&
        this.parent.selectingIds.indexOf(this.params.data._id) > -1
      );
    },
    isDeleting() {
      return (
        !!this.params.data &&
        this.parent.deletingIds.indexOf(this.params.data._id) > -1
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/empresas/components/CompanyActions.vue